/*
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-02 13:42:33
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-02 15:13:17
 */
import request from '@/utils/request'
// 列表
const list = '/rest/base/project-dept/page'
// 新增
const add = '/rest/base/project-dept/save'
// 位置
const position = '/rest/base/project-dept/list'
// 根据字典类型查询字典列表
const listDictByTypeUrl = '/rest/base/dict/listDictByType'

/**
 * @description: 列表
 * @param        {object} params 请求接口参数：pageNo='页码'，pageSize='每页条数'
 * @return       {object} res
 */
export async function getDeptlist (params) {
  return request.get(list, {
    ...params,
  })
}

/**
 * @description: 位置字典
 * @param        {object} 参数
 * @return       {object} res
 */
export async function getlistDictByType (params) {
  return request.get(listDictByTypeUrl, {
    ...params,
  })
}

/**
 * @description: 获取位置
 * @return       {object} res
 */
export async function getPosition (params) {
  return request.get(position)
}

/**
 * @description: 获取详情
 * @return       {object} res
 */
export async function getDeptDetailData (params) {
  return request.get(`/rest/base/project-dept/${params}/detail`, {
    ...params,
  })
}

/**
 * @description: 新增
 * @param        {object} 参数
 * @return       {object} res
 */
export async function deptSave (params) {
  return request.post(add, {
    ...params,
  }, {}, 2)
}

/**
 * @description: 更新
 * @param        {object} 参数
 * @return       {object} res
 */
export async function updateDept (params) {
  return request.post(`/rest/base/project-dept/${params.id}/update`, {
    ...params,
  }, {}, 2)
}

/**
 * @description: 删除
 * @param        {object} params id='项目部id'
 * @return       {object} res
 */
export async function deleteDept (params) {
  return request.post(`/rest/base/project-dept/${params}/del`, {
    ...params,
  })
}
